import { mdiHelpCircleOutline } from '@mdi/js';
import { appRoutes, faqsPageMessages, loginMessages, useAppSelector, UserState, useRubricheLogic } from 'azshared';
import React, { useCallback, useMemo } from 'react';
import { useIntl } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import { AppBreadcrumb } from '../breadcrumb/app-breadcrumb';
import { AppButton, AppButtonVariant } from '../buttons/app-button';
import './header.scss';
import { AppSearchableSelect, AppSearchableSelectOption } from '../select/app-searchable-select';

interface AppHeaderProps {
  faqPage?: boolean;
}

export const AppHeader = (props: AppHeaderProps) => {
  const { faqPage } = props;
  const { formatMessage } = useIntl();
  const navigate = useNavigate();
  const userState: UserState = useAppSelector((state) => state.data.user);

  const { rubriche, rubrica, rubricaLabel, rubricaLogicEnabled, onChange } = useRubricheLogic();

  const goToFaqPage = useCallback(() => {
    navigate(appRoutes.Faqs);
  }, [navigate]);

  const options: AppSearchableSelectOption[] = useMemo(() => {
    return rubriche.map((r) => ({ value: r.codiceRubrica ?? '', label: r.nominative ?? '' }));
  }, [rubriche]);

  return (
    <div className='header'>
      <div className='header-breadcrumb'>
        <AppBreadcrumb />
      </div>
      <div className='header-button-section'>
        {userState.userType === 'PG' && rubricaLogicEnabled && (
          <div>
            <AppSearchableSelect
              value={{ value: rubrica, label: rubricaLabel }}
              options={options}
              placeholder={formatMessage(loginMessages.selectRubrica)}
              onChange={onChange}
              style={customStyles(options.length)}
            />
          </div>
        )}
        <div className='faq'>
          <AppButton
            iconLeft={mdiHelpCircleOutline}
            variant={faqPage ? AppButtonVariant.Primary : AppButtonVariant.Secondary}
            label={formatMessage(faqsPageMessages.buttonLabel)}
            onClick={goToFaqPage}
          />
        </div>
      </div>
    </div>
  );
};

const customStyles = (optionsLength: number) => ({
  input: (provided: any) => ({
    ...provided,
    fontFamily: ['Futura-Book', 'sans-serif'],
    fontSize: '0.75rem',
    lineHeight: '0.875rem',
    color: '#8F95B2'
  }),
  option: (provided: any) => ({
    ...provided,
    fontFamily: ['Futura-Book', 'sans-serif'],
    fontSize: '0.75rem',
    lineHeight: '0.875rem',
    color: '#8F95B2'
  }),
  placeholder: (provided: any) => ({
    ...provided,
    fontSize: '11px'
  }),
  control: (provided: any) => ({
    ...provided,
    border: '1px solid #D8DAE5',
    display: optionsLength < 10 ? 'none' : 'flex', // Hide the input to get the list only
    borderRadius: '1.4285rem'
  }),
  menu: (provided: any) => ({
    ...provided,
    padding: '15px',
    marginTop: '15px'
  })
});
